module.exports = __webpack_public_path__ + "img/grey-trainings-1.290323b5.png";